import { useState, useCallback } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

import { BACKEND_URL } from '../lib/backend';

const API = `${BACKEND_URL}/api`;

export const useFeatureAccess = () => {
  const { user } = useAuth();
  const [checking, setChecking] = useState(false);

  const checkAccess = useCallback(async (featureName) => {
    if (!user) {
      return { allowed: false, reason: 'not_logged_in' };
    }

    // Premium users always have access
    if (user.subscription_tier === 'stellar' || user.subscription_tier === 'cosmic') {
      return { allowed: true, is_premium: true };
    }

    setChecking(true);
    try {
      const response = await axios.get(
        `${API}/feature/check/${featureName}`,
        { withCredentials: true }
      );
      setChecking(false);
      return response.data;
    } catch (error) {
      setChecking(false);
      console.error('Error checking feature access:', error);
      // Default to allowed if check fails (graceful degradation)
      return { allowed: true, error: true };
    }
  }, [user]);

  const incrementUsage = useCallback(async (featureName) => {
    // This is called after successful feature use
    // The backend handles incrementing automatically, this is just for UI updates
  }, []);

  const getLimits = useCallback(async () => {
    try {
      const response = await axios.get(
        `${API}/subscription/limits`,
        { withCredentials: true }
      );
      return response.data;
    } catch (error) {
      console.error('Error getting limits:', error);
      return null;
    }
  }, []);

  return {
    checkAccess,
    incrementUsage,
    getLimits,
    checking,
    isPremium: user?.subscription_tier === 'stellar' || user?.subscription_tier === 'cosmic',
    currentTier: user?.subscription_tier || 'free'
  };
};

export default useFeatureAccess;
